import Swal from 'sweetalert2';

/**
 * Fetches data using the provided fetchAction and handles the result.
 * @async
 * @function
 * @param {Object} props - The props object.
 * @param {Function} props.dispatch - The dispatch function from Redux.
 * @param {Function} props.fetchAction - The Redux action to fetch data.
 * @param {string} props.id - The ID of the data to fetch.
 * @param {string} props.errorMessage - The error message to display if the fetch fails.
 * @param {boolean} [props.navigateOnFailure=false] - Whether to navigate to a different page on failure.
 * @param {string} [props.navigateTo=''] - The path to navigate to on failure.
 * @param {Function} navigate - The navigate function from React Navigation.
 * @returns {boolean} - Whether the fetch was successful.
 */
const fetchAndHandleData = async (props) => {
    const {
        dispatch,
        navigate,
        fetchAction,
        id,
        errorMessage = 'Failed to fetch data.',
        navigateOnFailure = false,
        navigateTo = ''
    } = props;

    let errorText;

    if (id) {
        const resultAction = await dispatch(fetchAction(id));
        if (fetchAction.fulfilled.match(resultAction)) {
            return Boolean(resultAction.payload);
        }

        errorText = resultAction.payload || errorMessage;
    }

    await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorText || errorMessage,
        showConfirmButton: true,
    });

    if (navigateOnFailure && navigateTo) {
        navigate(navigateTo, { replace: false });
    }

    return false;
};

export default fetchAndHandleData;
